import cn from 'classnames';

import ArrowForward from 'assets/icons/arrow-forward.svg';

import BaseCta, { BaseCtaProps } from '../BaseCta';

import styles from './Cta.module.scss';

export type CtaProps = BaseCtaProps & {
  showIcon?: boolean;
  theme?: 'light' | 'dark' | 'filled';
};

const Cta = (props: CtaProps): JSX.Element => {
  const { className, children, showIcon, theme, ...otherProps } = props;

  return (
    <BaseCta
      className={cn(styles.main, className, {
        [styles['no-icon']]:
          showIcon === false || (showIcon === undefined && props.tag === 'button'),
        [styles['theme-dark']]: theme === 'dark',
        [styles['theme-filled']]: theme === 'filled',
      })}
      {...otherProps}
    >
      {children}
      <ArrowForward className={styles.arrow} />
    </BaseCta>
  );
};

export default Cta;
